import BasicInfoPopup from '../BasicInfoPopup/BasicInfoPopup';
import { IBasicInfoPopupProps } from '../BasicInfoPopup/BasicInfoPopup.types';
import { useCart } from '../../../contexts/CartContext/CartContext.hooks';

const DuplicateCustomerPopup = (props: IBasicInfoPopupProps) => {
    const text = `Welcome Back! It looks like you already started an order or have an account with us. To continue with your order, please chat with us online or call us at 1.877.842.3765.  For any customer support needs, feel free to chat with us online or call us at 1.877.484.2376.  We are here to assist you!`;

    const { clearCart } = useCart();

    const handlePopupSet = (value: boolean) => {
        window.location.href = '/';
        scrollTo(0, 0);
        clearCart();
        props.setPopup(value);
    };

    return <BasicInfoPopup {...props} popupText={text} setPopup={handlePopupSet} />;
};

export default DuplicateCustomerPopup;
